import { render } from "./AuthorPosts.vue?vue&type=template&id=15127026"
import script from "./AuthorPosts.vue?vue&type=script&lang=js"
export * from "./AuthorPosts.vue?vue&type=script&lang=js"

import "./AuthorPosts.vue?vue&type=style&index=0&id=15127026&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__